window.appmakerProducts = {
  pwaToApkPrice: 19,
  web2DeskWhiteLabelPrice: 19,
  web2DeskSourceCodePrice: 49,
  web2DeskInstallerPrice: 49,
//   web2DeskInstallerAndSourceCodePrice: 98,
};
